export default "__VITE_ASSET__DJRut5ZW__"